module.exports = __webpack_public_path__ + "static/media/tint.9b0778d6.svg";